import { strings } from './strings';
import { styles } from './styles';
import { ExperienceTheme } from '../ThemeTypes';

export const vam: ExperienceTheme = {
  strings,
  styles
};
